import { render, staticRenderFns } from "./wfgloballogin.vue?vue&type=template&id=0ac71535&"
import script from "./wfgloballogin.vue?vue&type=script&lang=js&"
export * from "./wfgloballogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports